import { Table, Input } from 'antd';
import { useState } from 'react';

interface JsonTableContent {
  columns: { key: string; title: string; dataType?: string }[];
  rows: Record<string, unknown>[];
}

interface JsonTableRendererProps {
  content: JsonTableContent;
  editable: boolean;
  onChange: (newContent: JsonTableContent) => void;
}

function JsonTableRenderer({
  content,
  editable,
  onChange,
}: JsonTableRendererProps) {
  const [editingCell, setEditingCell] = useState<{
    rowIndex: number;
    key: string;
  } | null>(null);

  const safeColumns = Array.isArray(content?.columns) ? content.columns : [];
  const safeRows = Array.isArray(content?.rows) ? content.rows : [];

  const columns = safeColumns.map((col) => ({
    title: col.title,
    dataIndex: col.key,
    key: col.key,
    render: (value: unknown, _record: Record<string, unknown>, rowIndex: number) => {
      const isEditing =
        editingCell?.rowIndex === rowIndex && editingCell?.key === col.key;

      if (editable && isEditing) {
        return (
          <Input
            size="small"
            defaultValue={String(value ?? '')}
            autoFocus
            onBlur={(e) => {
              const updatedRows = [...safeRows];
              updatedRows[rowIndex] = {
                ...updatedRows[rowIndex],
                [col.key]: e.target.value,
              };
              onChange({ ...content, rows: updatedRows });
              setEditingCell(null);
            }}
            onPressEnter={(e) => {
              (e.target as HTMLInputElement).blur();
            }}
          />
        );
      }

      return (
        <span
          className={editable ? 'editable-cell' : undefined}
          onClick={() =>
            editable && setEditingCell({ rowIndex, key: col.key })
          }
        >
          {String(value ?? '')}
        </span>
      );
    },
  }));

  return (
    <Table
      columns={columns}
      dataSource={safeRows.map((row, i) => ({ ...row, key: i }))}
      pagination={false}
      size="small"
      scroll={{ y: 300 }}
    />
  );
}

export default JsonTableRenderer;
